import React from 'react';

function RedirectPage({ to }: { to: string }) {
    window.location.replace(to);
    return <></>;
}

export default RedirectPage;
